import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { wait } from "../utility/wait";

interface EventControlQuestionProps {
  eventControllable: boolean | null;
  setEventControllable: React.Dispatch<React.SetStateAction<boolean | null>>;
  isAutoPageTurn?: boolean;
  questionnairePage: number;
  switchTab: (next: number) => void;
}

export const EventControlQuestion: React.FC<EventControlQuestionProps> = ({
  eventControllable,
  setEventControllable,
  isAutoPageTurn,
  questionnairePage,
  switchTab,
}) => {
  const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    setEventControllable(event.target.value === "true");
    if (isAutoPageTurn) {
      await wait(100);
      switchTab(questionnairePage + 1);
    }
  };
  return (
    <>
      <Box sx={{ p: "1rem" }}>
        <Typography variant="caption">
          思い出した出来事は、あなた自身の行動や判断が関係していますか？
        </Typography>
      </Box>
      <Box sx={{ padding: "1rem" }}>
        <FormControl>
          <RadioGroup
            onChange={handleChange}
            value={
              eventControllable === null ? "null" : eventControllable.toString()
            }
          >
            <FormControlLabel
              value="true"
              control={<Radio />}
              label="はい（関係している）"
            />
            <FormControlLabel
              value="false"
              control={<Radio />}
              label="いいえ（関係していない）"
            />
          </RadioGroup>
        </FormControl>
      </Box>
    </>
  );
};
